<div class="header-container">
    <mat-toolbar class="header">
        <img class="logo" src="/assets/img/logo.svg" (click)="navigateTo('selector')" />
        <mat-divider vertical class='main-divider'></mat-divider>
        <h3 class="project-name">
            Document Checking Application
        </h3>

                <span class="spacer"></span>

        <shared-header-menu [user]="user$()" [headerMenuElements]="
          headerMenuElements ? headerMenuElements : (headerMenuElements$ | async) ?? undefined
        " (headerNavigationEvent)="navigateTo($event)"></shared-header-menu>
    </mat-toolbar>
    @if ((apiLoading$ | async)?.includes(true)) {
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
    }
</div>
